import React from 'react';
import { withCopies } from 'src/services/TranslationService';

// Utils
import { checkCustomErrorMessage } from 'src/utils/validations-form';

const ErrorForm = (props) => {
    const getError = (error, isKey) => {
        const { t } = props;
        let errorIsKey = checkCustomErrorMessage(error);
        if (!errorIsKey && isKey) {
            errorIsKey = error;
        }
        if (typeof error !== 'undefined') {
            if (typeof error === 'string') {
                return errorIsKey ? t(errorIsKey) : error;
            } else {
                return '';
            }
        } else {
            return null;
        }
    };

    return (<span>{ getError(props.error, props.isKey) }</span>);
};

export default withCopies(ErrorForm);
